import { parseCallout, extractMarkdownLink } from "./parse";
import { EntityChip } from "../EntityChip";

const ENTITY_URL_PATTERN =
  /(?:map\.combify\.com|staging\.eu-west-1\.combify\.com|localhost(?::\d+)?)\/(property|project|permit|tender)\/([^\s)]+)/;

/** Render inline markdown: **bold** and [links](url) */
function renderInlineMarkdown(
  text: string,
  onEntityClick?: (entityType: string, entityId: string, name: string) => void,
): React.ReactNode[] {
  // Split on **bold** and [link](url) patterns
  const parts = text.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g);
  return parts.map((part, i) => {
    // Bold
    const boldMatch = part.match(/^\*\*(.+)\*\*$/);
    if (boldMatch) {
      return <strong key={i}>{boldMatch[1]}</strong>;
    }
    // Entity link
    const link = extractMarkdownLink(part);
    if (link && onEntityClick) {
      const entityMatch = link.url.match(ENTITY_URL_PATTERN);
      if (entityMatch) {
        return (
          <EntityChip
            key={i}
            entityType={entityMatch[1]!}
            entityId={entityMatch[2]!}
            onClick={onEntityClick}
          >
            {link.name}
          </EntityChip>
        );
      }
    }
    return <span key={i}>{part}</span>;
  });
}

interface CalloutCardProps {
  content: string;
  onEntityClick?: (entityType: string, entityId: string, name: string) => void;
}

export function CalloutCard({ content, onEntityClick }: CalloutCardProps) {
  const { label, body } = parseCallout(content);
  if (!body) return null;

  return (
    <div className="cx-callout">
      {label && <div className="cx-callout-label">{label}</div>}
      <div className="cx-callout-body">
        {renderInlineMarkdown(body, onEntityClick)}
      </div>
    </div>
  );
}
